export default __webpack_public_path__ + "static/media/cont12.b2c34898.png";